<template>
    <div class="HomeHionSocio">
        <PageTitle icon="fas fa-user-lock iconInterativoTitulo" main="PLATAFORMA SÓCIOS HION"
            sub="Dashboard Interativo" />

        <hr class="ml-2 mr-2">
        
    </div>
</template>

<script>
//import VueScrollTo from 'vue-scrollto'
import PageTitle from '../PageTitle'
import { mapState } from 'vuex'
//import { baseApiUrl, userKey, showError } from '../../../global'
//import axios from 'axios'

export default {
    name: 'HomeHionSocio',
    components: { PageTitle } ,
    data: function() {
        return {
           
        }
    },
    computed: mapState(['MenuVisivel', 'usuario']),
    methods: {
        
    },
    mounted() {
        
    }
}
</script>

<style>
    .HomeHionSocio {
        position: relative;
        width: 100%;
        height: 100%;
    }
</style>